<div class="container-fluid">
  <div class="advertisement">
    <div class="ad-content">
      <div class="keyboard">
        <h1 class="key">B</h1>
        <h1 class="key">I</h1>
        <h1 class="key">E</h1>
        <h1 class="key">N</h1>
        <h1 class="key">V</h1>
        <h1 class="key">E</h1>
        <h1 class="key">N</h1>
        <h1 class="key">I</h1>
        <h1 class="key">D</h1>
        <h1 class="key">O</h1>
      </div>
      <h2>¿Aún no tenés una cuenta?</h2>
      <button mat-stroked-button [routerLink]="['/registrarse']" color="primary">Registrarse</button>

    </div>
  </div>
  <div class="form-container">
    <div class="form-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
